/**
 * Serialise an object for a <script type="application/ld+json"> block.
 *
 * Escapes <, >, and & as unicode sequences so that strings containing
 * markup (e.g. user-submitted "</script><script>...") cannot break out
 * of the script tag and execute. The output remains valid JSON, so
 * search engines parse the structured data exactly as before.
 *
 * Always use this instead of raw JSON.stringify when rendering JSON-LD
 * via dangerouslySetInnerHTML.
 */
export function jsonLdScript(data: object): string {
  return JSON.stringify(data)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026");
}

/**
 * BreadcrumbList JSON-LD mirroring a page's visible breadcrumb nav.
 * Pass crumbs in order; the final crumb (the current page) should omit
 * `url` per Google's guidance. URLs may be relative; they are made
 * absolute here.
 */
export function breadcrumbLd(
  items: { name: string; url?: string }[]
): object {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      ...(item.url
        ? {
            item: item.url.startsWith("http")
              ? item.url
              : `https://tradesfolk.co${item.url}`,
          }
        : {}),
    })),
  };
}
